// Flag images from: https://flagdownload.com/

export const titlesData = [
    {
        flag: '/images/serbia.png',
        title: 'JUNIOR CHAMPION SERBIA',
        number: '0088/22/P / 10.05.2022',
        finished: true,
    },
    {
        flag: '/images/macedonia.png',
        title: 'JUNIOR CHAMPION MACEDONIA',
        number: '210-J-SK/2022 / 23.05.2022',
        finished: true,
    },
    {
        flag: '/images/greece.png',
        title: 'JUNIOR CHAMPION GREECE',
        number: '2454/2023 / 22.05.2023',
        finished: true,
    },
    {
        flag: '/images/romania.png',
        title: 'JUNIOR CHAMPION ROMANIA',
        number: 'JCAC 1 of 2 - Not finished',
        finished: false,
    },
    {
        flag: '/images/serbia.png',
        title: 'CHAMPION SERBIA',
        number: '0615/23 / 26.07.2023',
        finished: true,
    },
    {
        flag: '/images/macedonia.png',
        title: 'CHAMPION NORTH MACEDONIA',
        number: '838-OH/2023 / 04.09.2023',
        finished: true,
    },
    {
        flag: '/images/bulgaria.png',
        title: 'CHAMPION BULGARIA',
        number: '06.04.2024',
        finished: true,
    },
    {
        flag: '/images/greece.png',
        title: 'CHAMPION GREECE',
        number: 'Waiting for certificate',
        finished: true,
    },
    {
        flag: '/images/europe.png',
        title: 'INTERNATIONAL CHAMPION',
        number: 'Waiting for certificate',
        finished: true,
    },
];